/**
 * Legacy hash deep-link compatibility for password-reset emails.
 *
 * Reset emails historically linked to the hash-routed legacy dashboard
 * (`https://<host>/#/reset-password/<code>`). The v3 route is
 * `/reset-password?code=<code>`. The api email template now emits the v3
 * form, but links from already-sent emails (valid 24h) must keep working,
 * as must any sent before the api fleet picks up the template change.
 */
export class LegacyResetLink {
  /**
   * Extracts the reset code from a legacy `#/reset-password/<code>` hash.
   * Returns null when the hash is not a legacy reset link.
   */
  static parseHash(hash: string): string | null {
    const match = /^#\/reset-password\/([^/?#]+)/.exec(hash);
    return match ? match[1] : null;
  }

  /** v3 destination for a given reset code (path + search, no origin). */
  static v3Url(resetCode: string): string {
    return `/reset-password?code=${encodeURIComponent(resetCode)}`;
  }
}
